import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Alert, AppBar, Badge, Box, Button, CircularProgress, Toolbar, Typography} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {CartContext} from '../context/CartContext';

function Navigation() {

    const [storeName, setStoreName] = useState(null);
    const {cartItems} = useContext(CartContext);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const cartItemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

    useEffect(() => {
        fetch('/api/storeName')
            .then(res => {
                if (!res.ok) {
                    throw new Error('Network response was not ok');
                }
                return res.json();
            })
            .then(data => {
                setStoreName(data)
                setLoading(false);
            })
            .catch(err => {
                setError(err.message);
                setLoading(false);
                console.error('Error fetching storeName:', err);
            });
    }, []);

    if (loading) {
        return <CircularProgress/>;
    }

    if (error) {
        return <Alert severity="error">Error fetching products: {error}</Alert>;
    }

    return (
        <AppBar position="sticky">
            <Toolbar>
                <Typography
                    variant="h6"
                    component={Link}
                    to="/"
                    sx={{flexGrow: 1, textDecoration: 'none', color: 'inherit'}}
                >
                    <span>{storeName || 'Square Store'}</span>
                </Typography>
                <Box sx={{display: 'flex', gap: 2}}>
                    <Button color="inherit" component={Link} to="/">
                        Products
                    </Button>
                    <Button color="inherit" component={Link} to="/cart" role="link" aria-label="Cart">
                        <Badge badgeContent={cartItemCount} color="error">
                            <ShoppingCartIcon/>
                        </Badge>
                        <Typography sx={{ml: 1}}>Cart</Typography>
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Navigation;
